module.exports = __webpack_public_path__ + "img/hero.5b12949c.png";